export default __webpack_public_path__ + "static/session-dont-b30937f14ff362e8fd7405881b96b107.png";